const COLORS = {
  psychology:      { bg: "rgba(122,138,154,0.16)", fg: "#4b5b6f", label: "Psychology" },
  sociology:       { bg: "rgba(173,148,108,0.18)", fg: "#6c5836", label: "Sociology" },
  philosophy:      { bg: "rgba(160,123,90,0.18)",  fg: "#5f4628", label: "Philosophy" },
  human_behavior:  { bg: "rgba(120,142,108,0.18)", fg: "#3d5530", label: "Human behavior" },
  relationships:   { bg: "rgba(195,126,103,0.20)", fg: "#874030", label: "Relationships" },
  neurology:       { bg: "rgba(140,120,180,0.20)", fg: "#3f2f6a", label: "Neurology" },
};

export default function CategoryBadge({ category, className = "" }) {
  const c = COLORS[category] || { bg: "rgba(0,0,0,0.06)", fg: "#444", label: category };
  return (
    <span
      data-testid={`category-${category}`}
      className={`inline-block text-[10px] tracking-[0.18em] uppercase font-semibold rounded-full px-2.5 py-1 ${className}`}
      style={{ backgroundColor: c.bg, color: c.fg }}
    >
      {c.label}
    </span>
  );
}

export const categoryLabel = (cat) => COLORS[cat]?.label || cat;
